import React from "react";

import { FieldPath, FieldValues } from "react-hook-form";

import SelectInput, { SelectInputProps } from "@/components/atoms/Form/SelectInput/SelectInput";
import { useStaticQuery } from "@/shared/apis/referenceApi";
import { IdNamePair } from "@/shared/domain";

import { RefType, staticTables } from "../utils";

type RefInputProps = {
    table: RefType;
    options?: (string | IdNamePair)[];
};

type RefSelectInputProps<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<SelectInputProps<TFieldValues, TName>, "options"> & RefInputProps;

const RefSelectInput = <
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
    table,
    options: paramsOptions,
    disabled = false,
    label,
    ...props
}: RefSelectInputProps<TFieldValues, TName>): React.ReactElement => {
    const staticTable = staticTables[table];
    const shouldUseParamsOptions = paramsOptions && paramsOptions.length > 0;
    const { options: remoteOptions, loading } = useStaticQuery(staticTable.path, !shouldUseParamsOptions);
    const options = shouldUseParamsOptions ? paramsOptions : remoteOptions;
    return (
        <SelectInput
            disabled={disabled || !options}
            options={options}
            label={label || label === "" ? label : staticTable.label}
            loading={loading}
            {...props}
        />
    );
};

export default RefSelectInput;
